module.exports = ".pagina {\n    min-height: 620px;\n    -webkit-transition: all 1s linear;\n    transition: all 1s linear;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/consulta-fluxos/consulta-fluxos.css
// module id = ./src/app/consulta-fluxos/consulta-fluxos.css
// module chunks = main